"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __esm = (fn, res, err) => function __init() {
  if (err) throw err[0];
  try {
    return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
  } catch (e) {
    throw err = [e], e;
  }
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/index-browser.ts
var index_browser_exports = {};
__export(index_browser_exports, {
  Logger: () => Logger
});
var _Logger, Logger;
var init_index_browser = __esm({
  "src/index-browser.ts"() {
    "use strict";
    _Logger = class _Logger {
      static debug(obj, logCode) {
        console.log(logCode ?? obj.msg ?? "", obj);
      }
      static info(obj, logCode) {
        console.info(logCode ?? obj.msg ?? "", obj);
      }
      static warn(obj, logCode) {
        console.warn(logCode ?? obj.msg ?? "", obj);
      }
      static error(obj, logCode) {
        console.error(logCode ?? obj.msg ?? "", obj);
      }
    };
    __name(_Logger, "Logger");
    Logger = _Logger;
  }
});

// src/index-server.ts
var index_server_exports = {};
__export(index_server_exports, {
  Logger: () => Logger2
});
var import_winston, import_os, combine, timestamp, printf, customFormat, customFormatPretty, winstonConfig, _Logger2, Logger2;
var init_index_server = __esm({
  "src/index-server.ts"() {
    "use strict";
    import_winston = require("winston");
    import_os = __toESM(require("os"));
    ({ combine, timestamp, printf } = import_winston.format);
    customFormat = printf((info) => `${JSON.stringify(info)}`);
    customFormatPretty = printf(({ level, message, timestamp: time, ...remainingArgs }) => `[${time}] (${level.toUpperCase()}) ${message ?? ""} (${import_os.default.hostname()}|${process.pid})${Object.keys(remainingArgs).length > 2 ? `
${JSON.stringify(remainingArgs, null, " ")}` : ""}`);
    winstonConfig = {
      level: process.env.LOG_LEVEL ?? "info",
      transports: [
        new import_winston.transports.Console()
      ],
      format: combine(timestamp(), customFormat)
    };
    if (process.env.NODE_ENV !== "production") {
      winstonConfig.format = combine(timestamp(), customFormatPretty);
    }
    _Logger2 = class _Logger2 {
      static debug(obj, logCode) {
        this.internalLogger.debug(obj.msg ?? obj.message ?? "", {
          ...obj,
          msg: void 0,
          message: void 0,
          logCode
        });
      }
      static info(obj, logCode) {
        this.internalLogger.info(obj.msg ?? obj.message ?? "", {
          ...obj,
          msg: void 0,
          message: void 0,
          logCode
        });
      }
      static warn(obj, logCode) {
        this.internalLogger.warn(obj.msg ?? obj.message ?? "", {
          ...obj,
          msg: void 0,
          message: void 0,
          logCode
        });
      }
      static error(obj, logCode) {
        this.internalLogger.error(obj.msg ?? obj.message ?? "", {
          ...obj,
          msg: void 0,
          message: void 0,
          logCode
        });
      }
    };
    __name(_Logger2, "Logger");
    __publicField(_Logger2, "internalLogger", (0, import_winston.createLogger)(winstonConfig));
    Logger2 = _Logger2;
  }
});

// src/index.ts
var index_exports = {};
__export(index_exports, {
  Logger: () => Logger3
});
module.exports = __toCommonJS(index_exports);
var Logger3;
if (typeof window !== "undefined") {
  const { Logger: BrowserLogger } = (init_index_browser(), __toCommonJS(index_browser_exports));
  Logger3 = BrowserLogger;
} else {
  const { Logger: ServerLogger } = (init_index_server(), __toCommonJS(index_server_exports));
  Logger3 = ServerLogger;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Logger
});
